import React, { useEffect, useRef } from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { v4 as uuid } from 'uuid';
import PendencyTag from './PendencyTag';
import { colorCommunicationType } from '../../../shared/utils/smartutils';
import {
  ATTACHMENT_TYPES,
  COMMUNICATION_TYPE,
} from '../../../shared/utils/constants';
import Gallery from '../../../shared/components/Gallery';
import FileWrapper from '../../../shared/components/FileWrapper';
import QuestionCard from '../../Communication/components/questionnaire/QuestionCard';
import EventHeaderCard from '../../../shared/components/EventHeaderCard';
import Anthropometric from './Anthropometric';
import { anthropometricMeasurementsPropTypes } from '../../../shared/utils/SmartPropTypes';

const CommunicationDetail = ({ t, communication, onCommunicationSelect }) => {
  const contentRef = useRef(null);

  const getTagValue = (type) => {
    return t(`communication.type-${type}`);
  };

  const getColor = () => {
    return colorCommunicationType()[communication.type];
  };

  const isGalleryFile = (fileType) => {
    return (
      fileType === ATTACHMENT_TYPES.VIMEO ||
      fileType === ATTACHMENT_TYPES.IMAGE ||
      fileType === ATTACHMENT_TYPES.YOUTUBE
    );
  };

  const getFiles = (files) => {
    return files.filter((file) => !isGalleryFile(file.fileType));
  };

  const getGalleryFiles = (files) => {
    return files.filter((file) => isGalleryFile(file.fileType));
  };

  useEffect(() => {
    contentRef.current.innerHTML = communication.htmlContent;
  }, []);

  return (
    <div className="communication-detail">
      <button type="button" onClick={onCommunicationSelect}>
        <div className="communication-detail-header">
          <PendencyTag
            color={getColor()}
            value={getTagValue(communication.type)}
          />
        </div>
        <div className="communication-detail-content">
          <div className="title">{communication.title}</div>
          <div className="mt-2" ref={contentRef} />
        </div>
        {communication.type === COMMUNICATION_TYPE.CALENDAR &&
          communication.eventHeader && (
            <EventHeaderCard eventHeader={communication.eventHeader} />
          )}
        {communication.type === COMMUNICATION_TYPE.SURVEY && (
          <div className="w-100">
            {communication.questions.map((item) => (
              <QuestionCard
                key={uuid()}
                question={item}
                hideQuestionnaire={false}
              />
            ))}
          </div>
        )}
      </button>
      <Gallery data={getGalleryFiles(communication.files)} />
      <FileWrapper files={getFiles(communication.files)} openBlank />
      {communication.type === COMMUNICATION_TYPE.ANTHROPOMETRIC && (
        <Anthropometric
          anthropometricMeasurements={communication.anthropometricMeasurements}
        />
      )}
    </div>
  );
};

CommunicationDetail.propTypes = {
  t: PropTypes.func.isRequired,
  onCommunicationSelect: PropTypes.func.isRequired,
  communication: PropTypes.shape({
    content: PropTypes.string,
    createdAtMili: PropTypes.number,
    creatorName: PropTypes.string,
    dueDateMili: PropTypes.number,
    editable: PropTypes.bool,
    hashId: PropTypes.string,
    htmlContent: PropTypes.string,
    id: PropTypes.number,
    scheduled: PropTypes.bool,
    scheduledTo: PropTypes.number,
    scheduledToHour: PropTypes.string,
    selected: PropTypes.bool,
    sent: PropTypes.bool,
    sentAt: PropTypes.number,
    title: PropTypes.string,
    type: PropTypes.string,
    updaterName: PropTypes.string,
    eventHeader: PropTypes.shape({
      allDay: PropTypes.bool,
      local: PropTypes.string,
      initialDate: PropTypes.number,
      finalDate: PropTypes.number,
      initialHour: PropTypes.string,
      finalHour: PropTypes.string,
    }),
    questions: PropTypes.arrayOf(
      PropTypes.shape({
        descriprion: PropTypes.string,
      })
    ),
    files: PropTypes.arrayOf(
      PropTypes.shape({
        fileName: PropTypes.string,
        fileType: PropTypes.string,
        preview: PropTypes.string,
        status: PropTypes.string,
        type: PropTypes.string,
      })
    ),
    anthropometricMeasurements: anthropometricMeasurementsPropTypes,
  }).isRequired,
};

export default withTranslation('common')(CommunicationDetail);
